export default "__VITE_ASSET__FYsk6rB1__"